import { render, staticRenderFns } from "./cortina.vue?vue&type=template&id=6212d796&scoped=true&"
import script from "./cortina.vue?vue&type=script&lang=js&"
export * from "./cortina.vue?vue&type=script&lang=js&"
import style0 from "./cortina.vue?vue&type=style&index=0&id=6212d796&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6212d796",
  null
  
)

export default component.exports